/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { InterventionViewModel } from './InterventionViewModel'; 

export function getInterventionsToPerformOptions(stayId: string, userId: string, onSuccess?: (result: InterventionViewModel[]) => void) {
	return queryOptions({
		queryKey: ['interventions-to-perform', stayId, userId],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/careplanning/goalsandinterventions/queries/getinterventionstoperform/' + stayId + '/' + userId;
			const resp = await axios.get<InterventionViewModel[]>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(stayId) && Boolean(userId)
	});
}